// Used by wizard#check_personal_record and users#edit and personal_record#edit
;(function () {
  window.aliveToggle = function (scope) {
    $("#user_personal_record_attributes_alive, #personal_record_alive").change(
      function (e) {
        $(
          ".user_personal_record_date_of_death, .personal_record_date_of_death"
        ).toggleClass("hidden", $(e.target).is(":checked"))
        return $(
          ".user_personal_record_place_of_death, .personal_record_place_of_death"
        ).toggleClass("hidden", $(e.target).is(":checked"))
      }
    )
    return $(
      "#user_personal_record_attributes_alive, #personal_record_alive"
    ).trigger("change")
  }
}).call(this)
